module.exports = __webpack_public_path__ + "static/media/delete-gray.f98248e8.svg";